import { Children } from "react";
var getSlideCount = function getSlideCount(children) {
  return Children.count(children);
};
export default getSlideCount;